import { render, staticRenderFns } from "./new-leave-application.vue?vue&type=template&id=70c809ce"
import script from "./new-leave-application.vue?vue&type=script&lang=js"
export * from "./new-leave-application.vue?vue&type=script&lang=js"
import style0 from "./new-leave-application.vue?vue&type=style&index=0&id=70c809ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports